import { defineMessages } from 'react-intl';

import generalMessages from 'src/messages';

const messages = defineMessages({
  editSequenceTitle: {
    id: 'editSequenceTitle',
    defaultMessage: 'Edit sequence'
  },
  editSequenceBackButtonLabel: {
    id: 'editSequenceBackButtonLabel',
    defaultMessage: 'Back to plate'
  },
  plateWells: {
    id: 'plateWells',
    defaultMessage: 'Plate wells',
  },
  primerName: {
    id: 'primerName',
    defaultMessage: 'Primer name',
  },
  oligoSequence: {
    id: 'oligoSequence',
    defaultMessage: 'Oligo sequence (5\' to 3\')',
  },
  modification5: {
    id: 'modification5',
    defaultMessage: '5\' Modification',
  },
  modification3: {
    id: 'modification3',
    defaultMessage: '3\' Modification',
  },
  saveChanges: {
    id: 'saveChanges',
    defaultMessage: 'Save changes',
  },
  preview: {
    id: 'preview',
    defaultMessage: 'Preview',
  },
  baseCount: {
    id: 'baseCount',
    defaultMessage: 'Base count: {count}',
  },
  oligosSequenceBasesError: {
    id: 'oligosSequenceBasesError',
    defaultMessage: 'Invalid base. Valid bases for oligo sequence include alphanumerical ' +
      'characters and optional square brackets. Spaces, new lines (Enter), or any other ' +
      'characters are not allowed.',
  },
  oligosSequenceLengthError: {
    id: 'oligosSequenceLengthError',
    defaultMessage: 'DNA oligos must be between {min} and {max} bases.'
  },
  oligosSequenceRequiredError: {
    id: 'oligosSequenceRequiredError',
    defaultMessage: 'Oligos sequence is required',
  },
  primerNameRequiredError: {
    id: 'primerNameRequiredError',
    defaultMessage: 'Primer name is required',
  },
  primerNameLengthError: {
    id: 'primerNameLengthError',
    defaultMessage: 'Primer name must have a maximum of {max} characters.',
  },
  primerNameSpecialCharError: {
    id: 'primerNameSpecialCharError',
    defaultMessage: 'Primer name contains invalid character, the invalid characters are ,' +
      '\'/~\\"',
  },
  primerNameStartsWithSpaceError: {
    id: 'primerNameStartsWithSpaceError',
    defaultMessage: 'Primer name should not start with space.',
  },
  plateDetailsTitle: {
    id: 'plateDetailsTitle',
    defaultMessage: 'Plate',
  },
  plateWellEditFailure: {
    id: 'plateWellEditFailure',
    defaultMessage: 'Failed saving you changes. Please try again.'
  },
  plateWellEditSuccess: {
    id: 'plateWellEditSuccess',
    defaultMessage: 'Your changes were sucessfully saved.'
  },
  plateDetailsFetchError: {
    id: 'plateDetailsFetchError',
    defaultMessage: 'Failed fetching the details for this plate. Try refreshing the page.'
  }
});

export default { ...generalMessages, ...messages };
